import { Style } from 'ol/style';

export default class GeometryCollectionTextStyle extends Style {
  constructor(textStyle) {
    super({
      text: textStyle,
      geometry(feature) {
        let retPoint;
        if (feature.getGeometry().getExternalPolygon) {
          retPoint = feature.getGeometry().getExternalPolygon();
        } else {
          retPoint = feature.getGeometry();
        }
        return retPoint;
      },
    });
  }
}
